import { FieldGroupData } from '../FieldGroup';
import { useIsReviewMode } from '../ViewContext';
import { getIsFieldHidden } from './useIsFieldHidden';

export function useIsGroupHidden(group: FieldGroupData) {
    const isReviewMode = useIsReviewMode();
    return !group.fields.some((field) => !getIsFieldHidden(field, isReviewMode));
}
